// extracted by mini-css-extract-plugin
export var container = "aboutus-module--container--2GWto";
export var oneliner = "aboutus-module--oneliner--p1b5u";
export var content = "aboutus-module--content--2Vd8U";
export var contactusContainer = "aboutus-module--contactusContainer--2dope";
export var contactusTitle = "aboutus-module--contactusTitle--2Fbdy";
export var contactusBody = "aboutus-module--contactusBody--3yJSU";
export var containerM = "aboutus-module--containerM--22usV";
export var containerMobile = "aboutus-module--containerMobile--26WoJ";
export var contentMobile = "aboutus-module--contentMobile--3ykH-";
export var contactusContainerMobile = "aboutus-module--contactusContainerMobile--t_8BA";
export var contactusTitleMobile = "aboutus-module--contactusTitleMobile--2XEoD";
export var contactusBodyMobile = "aboutus-module--contactusBodyMobile--1ZnZc";